import * as React from "react";
import {match, Redirect, Switch} from "react-router";
import AdminRoute from "./route/AdminRoute";
import ActivityTemplateList from "../components/admin/surveyQuestionsTool/ActivityTemplateList";
import ActivityTemplateDetails from "../components/admin/surveyQuestionsTool/ActivityTemplateDetails";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 *  Survey related stuff router.
 */
export default class SurveyRouter extends React.PureComponent <RouteProps, {}> {

	render() {
		return (
			<Switch>
				<AdminRoute exact path={this.props.match.url} component={ActivityTemplateList}/>
				<AdminRoute exact path={this.props.match.url + "/:activityId"} component={ActivityTemplateDetails}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		)
	}

}